import React from 'react'
import RupayUPIReport from '../../myapp/trns-report/rupayUPI'

function RupayUPIReportPage() {
  return (
    <RupayUPIReport/>
  )
}

export default RupayUPIReportPage